import React, {Component} from 'react';
import {FaIcon} from "../FaIcon";
import { withTranslation } from 'react-i18next';

export class UrlAlertTooltipClass extends Component {
    render() {
        const { t } = this.props;
        return (
            <div className="bu-tooltip">
                <FaIcon iconName="unlink"/>
                <p className="tooltip-description">{t('url_alert_tooltip.oh_no_down_urls', {count: this.props.downUrlsCount})}</p>
            </div>

        )
    }
}

export const UrlAlertTooltip = withTranslation()(UrlAlertTooltipClass);
export default UrlAlertTooltip;